import React, { useEffect } from "react";
import {
  CheckMoreButton,
  HomeSlideContainer,
  HomeSlideInfosBox,
  HomePageWrapper,
} from "./home.styles";
import { ReactComponent as AddCircle } from "../../assets/icons/add-circle.svg";
import SectionImportantLinks from "./sections/important-links";
import SectionQuickAccess from "./sections/quick-access";
import SectionNewsHighlights from "./sections/newsHighlights";
import SectionPublicationsTabs from "./sections/section-publications-tabs";
import { useHomeController } from "./context/home-controller";
import { useHomeState } from "./context/home-context";
import { HomeSkeleton } from "../components/shared/skeletons";

export function HomeComponent() {
  const { loadBanners, loadNews, setActiveSlide, loadGroupedDailyOfficial, loadCategoriesWithSubcategories } = useHomeController();
  const { banners, activeSlide, loading, loadingNews } = useHomeState();

  useEffect(() => {
    loadBanners();
    loadNews();
    loadGroupedDailyOfficial();
    loadCategoriesWithSubcategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (banners.length === 0) return;

    const interval = setInterval(() => {
      const nextSlide = activeSlide === banners.length - 1 ? 0 : activeSlide + 1;
      setActiveSlide(nextSlide);
    }, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSlide, banners.length]);

  if (loading || loadingNews) {
    return <HomeSkeleton />;
  }

  return (
    <HomePageWrapper>
      {banners.length > 0 && (
        <section>
          <HomeSlideContainer>
            <img alt={banners[activeSlide].title || ''} src={banners[activeSlide].urlImage} />
            {banners[activeSlide].url && (
              <HomeSlideInfosBox>
                <CheckMoreButton
                  onClick={() => window.open(banners[activeSlide].url, '_blank')}
                >
                  Saiba mais <AddCircle />
                </CheckMoreButton>
              </HomeSlideInfosBox>
            )}
          </HomeSlideContainer>
        </section>
      )}

      <SectionQuickAccess />
      <SectionImportantLinks />
      <SectionNewsHighlights />
      <SectionPublicationsTabs />
    </HomePageWrapper>
  );
}
